import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center" }

import { reformatDateString } from '@/helpers/dates'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

interface Props {
  /** Reference object data */
  reference: Pick<ReferenceInterface, 'date' | 'flags'>
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ReferenceDate'
},
  __name: 'ReferenceDate',
  props: {
    reference: {}
  },
  setup(__props: any) {





const { t } = useI18n()

const tooltip = computed(() => {
  if (__props.reference.flags.is_overdue) {
    return t('references.flags.is_overdue')
  }

  return null
})

return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_unref(reformatDateString)(__props.reference.date)), 1),
    (__props.reference.flags.is_overdue)
      ? (_openBlock(), _createBlock(_component_VIcon, {
          key: 0,
          icon: "$alert-circle-outline",
          size: "1rem",
          class: "is_overdue ml-0.5"
        }))
      : _createCommentVNode("", true)
  ])), [
    [_directive_tooltip, tooltip.value]
  ])
}
}

})